import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { Role } from '../main/models/role-model';
import { evaluationPanelPaths } from './models/path-model';

const EvaluationPanelList = React.lazy(
  () => import('../evaluation-panel/pages/evaluation-panel-list'),
);

const EvaluationPanelStoryResumePage = React.lazy(
  () => import('../evaluation-panel/pages/evaluation-panel-story-resume-page'),
);

const EvaluationPanelAdminStoryResumePage = React.lazy(
  () =>
    import(
      '../evaluation-panel/pages/evaluation-panel-admin-story-resume-page'
    ),
);

export const evaluationPanelRoutes: Sebrae.RoutesConfig = [
  {
    routePath: evaluationPanelPaths.list,
    ifHaveTheseRoles: [Role.admin, Role.evaluator],
    pageToRender: <EvaluationPanelList />,
  },
  {
    routePath: evaluationPanelPaths.storyResume,
    ifHaveTheseRoles: [Role.admin, Role.evaluator],
    pageToRender: <EvaluationPanelStoryResumePage />,
  },
  {
    routePath: evaluationPanelPaths.adminStoryResume,
    ifHaveTheseRoles: [Role.admin],
    pageToRender: <EvaluationPanelAdminStoryResumePage />,
  },
];
